import { render, staticRenderFns } from "./DashboardAnalytics.vue?vue&type=template&id=0a84ff80"
import script from "./DashboardAnalytics.vue?vue&type=script&lang=js"
export * from "./DashboardAnalytics.vue?vue&type=script&lang=js"
import style0 from "./DashboardAnalytics.vue?vue&type=style&index=0&id=0a84ff80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports